export default [{
  path: 'entpEvaluationsList',
  name: 'entpEvaluationsList',
  component: function component() {
    return import('@/views/entpEvaluations/index');
  }
}, {
  path: 'entpEvaluationsAdd',
  name: 'entpEvaluationsAdd',
  component: function component() {
    return import('@/views/entpEvaluations/add');
  }
}, {
  path: 'entpEvaluationsUpdate',
  name: 'entpEvaluationsUpdate',
  component: function component() {
    return import('@/views/entpEvaluations/update');
  }
}, {
  path: 'entpEvaluationsDetail',
  name: 'entpEvaluationsDetail',
  component: function component() {
    return import('@/views/entpEvaluations/detail');
  }
}, {
  path: 'entpYearEvaluationsList',
  name: 'entpYearEvaluationsList',
  component: function component() {
    return import('@/views/entpYearEvaluations/index');
  }
}, {
  path: 'entpYearEvaluationsDetail',
  name: 'entpYearEvaluationsDetail',
  component: function component() {
    return import('@/views/entpYearEvaluations/detail');
  }
}];